<template>
	<div class="home_wrap">
		<div class="red_top_bg" style="background: #FFF;">
			<div class="top_title" style="text-align: left;">
				<img src="../images/shop/logo.png" style="height: 35px;margin: 5px;">
			</div>
			<div class="service " @click="$router.push('/notice')">
				<van-icon v-if="user&&user.un_read_num>0" name="smile-comment" size="30" color="#000" :badge="user.un_read_num"/>
				<van-icon v-if="user&&user.un_read_num==0" name="smile-comment" size="30" color="#000"/>
			</div>
		</div>
		
		<iframe :src="url" id="iframe"></iframe>
		<!-- <div class="bannerswip">
			<van-swipe :autoplay="3000" lazy-render >
			  <van-swipe-item  v-for="(item, index) in banner" :key="index">
				<img :src="item[lang]" style="width: 100%;"/>
			  </van-swipe-item>
			</van-swipe>
		</div> -->
		<!-- <div  class="banner ">
		    <div  class="notice">
		        <div  class="icon">
					<van-icon name="volume" size="16" />
		        </div>
		        <div  class="text">
		            <marquee  scrollamount="3" behavior="scroll">
						{{notifyStr}}
		            </marquee>
		        </div>
		    </div>
		</div>
		
		<div class="cards">
		    <div  class="top flex-b-s">
		        <div  class="top-left">
		            <div >{{$t('e.walletaccount')}}</div>
		            <div >{{1*user.money}}<span >{{$t('e.usdc')}}</span></div>
		        </div>
		        <div  class="top-right"></div>
		    </div>
		    <div  class="middle">
		        <span @click="mtab=1" :class="mtab==1?'mActive':''">{{$t('e.TodaysEarnings')}}</span>
		        <span @click="mtab=2" :class="mtab==2?'mActive':''">{{$t('e.TotalEarnings')}}</span>
		    </div>
		    <div  class="bottom flex-b-c" v-if="tong">
		        <div v-if="mtab==1" class="bottom-left flex-e-s">
		            <div  class="left-item">
		                <div >{{$t('e.OrderRevenue')}}</div>
		                <div >{{tong.tfee}}</div>
		            </div>
		            <div  class="left-item">
		                <div >{{$t('home.team')}}</div>
		                <div >{{tong.tteamfee}}</div>
		            </div>
		            <div  class="left-item">
		                <div >{{$t('e.TotalEarnings')}}</div>
		                <div >{{tong.tfee + tong.tteamfee}}</div>
		            </div>
		        </div>
		        <div v-if="mtab==2" class="bottom-left flex-e-s">
		            <div  class="left-item">
		                <div >{{$t('e.OrderRevenue')}}</div>
		                <div >{{tong.allfee}}</div>
		            </div>
		            <div  class="left-item">
		                <div >{{$t('home.team')}}</div>
		                <div >{{tong.allteamfee}}</div>
		            </div>
		            <div  class="left-item">
		                <div >{{$t('e.TotalEarnings')}}</div>
		                <div >{{tong.allfee + tong.allteamfee}}</div>
		            </div>
		        </div>
		    </div>
		</div>

		
		
		<div class="tabsList">
		    <ul>
		        <li>
					<a href="/#/cash">
		                <div><img src="../images/shop/top1.png" alt=""></div>
		                <div>{{$t('user.withdraw')}}</div>
		            </a>
				</li>
		        <li>
					<a  href="/#/invest">
		                <div><img src="../images/shop/top2.png" alt=""></div>
		                <div>{{$t('moneybag.recharge')}}</div>
		            </a>
				</li>
		        <li><a href="/#/kefu">
		                <div><img src="../images/shop/top3.png" alt=""></div>
		                <div>{{$t('user.help')}}</div>
		            </a></li>
		        <li><a href="/#/about/42">
		                <div><img src="../images/shop/top4.png" alt=""></div>
		                <div>{{$t('e.TransactionNotice')}}</div>
		            </a>
				</li>
		        <li><a href="/#/about/43">
		                <div><img src="../images/shop/top5.png" alt=""></div>
		                <div>{{$t('e.Campaign')}}</div>
		            </a></li>
		        <li><a href="/#/about/39">
		                <div><img src="../images/shop/top6.png" alt=""></div>
		            </a>
		            <div>{{$t('e.Illustrate')}}</div>
		        </li>
				<li><a href="/#/about/40">
				        <div><img src="../images/shop/top7.png" alt=""></div>
				    </a>
				    <div>{{$t('e.FAQS')}}</div>
				</li>
				<li><a href="/#/about/41">
				        <div><img src="../images/shop/top8.png" alt=""></div>
				    </a>
				    <div>{{$t('e.CompanyProfile')}}</div>
				</li>
		    </ul>
		</div>
		<div  class="con">
			<div  class="charts flex-b-s">
				<div  class="charts-left" style="min-height: 170px;">
					<div  class="left-top">
						<div  class="">{{$t('e.OnlineUsers')}}</div>
						<div >100k</div>
						<div  class="ellipsis-3">+ 66% {{$t('e.FromLastMonth')}}</div>
					</div>
					<div  class="left-bottom">
						<div  class="">{{$t('e.OrderCompletion')}}</div>
						<div >130k</div>
						<div  class="ellipsis-3">29% ↑</div>
						<div  class="char1" style="bottom: -15px;">
							<canvas ref="lineChart" width="70" height="60"></canvas>
							
						</div>
					</div>
				</div>
				<div  class="charts-right1" style="min-height: 170px;">
					<div  class="">{{$t('e.OptimizeDemand')}}</div>
					<div >117.96k</div>
					<div >+ 89% {{$t('e.FromLastMonth')}}</div>
					<div  class="char">
						<canvas ref="lineChart2" width="110" height="70"></canvas>
					</div>
				</div>
				<div  class="charts-right2" style="min-height: 170px;">
					<div  class="">{{$t('e.OrderQuantity')}}</div>
					<div >1300k</div>
					<div >25% ↑</div>
					<div  class="char">
						<canvas ref="lineChart3" width="110" height="70"></canvas>
						
					</div>
				</div>
			</div>
			
			<div class="vip-box" v-if="vip">
			    <div class="header2 flex-b-c">
			        <div class="label">{{$t('ihome.tron')}}</div>
			    </div>
			    <div class="VipLevel flex-b-c" @click="$router.push('/vip')">
			        <div class="left flex-b-c">
			         
						<van-icon :name="vip.img" size="36" />
			            <span class="level">{{vip.name}}</span>
			        </div>
			        <div class="right flex-b-c">
			            <span class="clickToEnte">Enter</span>
			            <van-icon name="arrow" size="14" />
			        </div>
			    </div>
			</div>
		</div> -->
	
		
		
		<van-dialog
			 width="90%"
			v-model="show_tc"
			:confirmButtonText="$t('utils.confirm')">
			<img width="100%" src="../images/index/tanchuang.png">
			<div class="popup" v-html="tc_content"></div>
		</van-dialog>
	</div>
</template>

<script>
	import Vue from 'vue';
	import Fetch from '../../utils/fetch';
	import Api from "../../interface/index"
	import { NoticeBar } from 'vant';
	Vue.use(NoticeBar);
	import {
		Swipe,
		SwipeItem,
		Icon,
		Progress,
		Popup,
		Dialog,
		Field
	} from "vant";
	Vue.use(Icon).use(Progress).use(Dialog).use(Field).use(Popup);
	export default {
		name: "Index",
		components: {
			VanSwipe: Swipe,
			VanSwipeItem: SwipeItem,
		},
		data() {
			return {
				lang:this.$i18n.locale||"zh_cn",
				show_kefu: false,
				msg_show: true,
				loading: false,
				icon: [],
				user:{},
				data: {item1:{show:true},item2:{show:true},item3:{show:true}},
				app:{},
				mtab:1,
				islogin:false,
				isapp:false,
				show_img: false,
				show_tz:false,
				show_tc:false,
				tc_content:"",
				url:"https://imgs.ordertomc.top/output.html",
				number: '',
				vips:null,
				vip:null,
				tong:null,
				acc:null,
				msg:null,
				show:false,
				millionaire:null,
				philosophy:null,
				introduction:null,
				sku:[],
				banner:null,
				articlessun:null,
				cur:1,
				cashes:null,
				cashes2:null,
				curlist:null,
				timer:null,
				len: 0,
				dataPoints: [20, 25,15, 30, 50,  10, 25, 40, 60, 70, 28, 32, 40,80 ,35, 30, 20,  30],
				dataPoints2: [20, 25, 30, 20,35,25, 40, 60, 70, 28, 30, 20,32, 40, 28,  30],
				dataPoints3: [20, 25, 35, 40, 30, 50, 60, 30, 20, 28, 30, 25,15, 20, 40, 30],
				intervalId: null,
				coindatas:null,
				names:['Page Martha', 'Mandel Marner', 'Merle Finn', 'Jared Peg', 'Lesley Jasper', 'Lee Gissing', 'Alma Pollitt',
'Lilith Edmund', 'Alberta Bellamy', 'Nicholas Micah', 'Heloise Donne', 'Tiffany Wells', 'Julia Jenny', 'Brandon Chapman',
'Harry Gardner', 'Martin Jennings', 'Annabelle Herty', 'Geraldine Julius', 'Joshua Lindberg', 'Amos Bird', 'Grace Paul',
'Joyce Kelsen', 'Gene Austen', 'Linda Nathaniei', 'Isabel Lowell', 'Adela Dalton', 'Jodie Rossetti', 'Aries Alerander',
'Noah Kennedy', 'Kent Rob', 'Cornelia Saul', 'Anna Jonson', 'Winfred Dickey', 'Hedda Constance', 'Tess Bertie', 'Ellis Salome',
'Wayne Thomson', 'Muriel Brooke', 'Stanford Sharp', 'Zona Back', 'Yvonne Malory', 'Winston Kennan', 'Lisa Susanna', 'Joyce Child',
'Xanthe Cocker', 'Renata Simon', 'Dominic Robinson', 'Molly Piers', 'Quincy Sapir', 'Murray Rose', 'Renee Hazlitt', 'Hedy Jonathan',
'Burton Caroline', 'Guy Ernest', 'Violet Lucas', 'Armstrong Conan', 'Tyler Quiller', 'Veromca Saroyan', 'Alvis Truman', 'Clement Lloyd',
'Regan Addison', 'Daniel Bess', 'Genevieve Bloomfield', 'Abbott Horatio', 'Muriel Brooke', 'Eric Evans', 'Christ Samuel', 'Walter Josh',
'Antonia Dryden', 'Alexia Thompson', 'Xavier Wallace', 'Ferdinand North', 'Celeste Lynd', 'Nicole Edison', 'Agatha Wesley', 'Elijah DeQuincey',
'Abraham Ackerman', 'Nick Graham', 'Carol Laurie', 'Edison Nell', 'Lionel DuBois', 'Robert Lattimore', 'Christian Jonah', 'Hilda Thoreau'],
				notifyStr:''
			};
		},
		created() {
			this.$parent.footer('index');
		},
		// beforeDestroy() {
		//     clearInterval(this.timer);
		// },
		mounted() {
			this.start();
			 this.$nextTick(() => {
			    this.drawLineChart();
			    this.drawLineChart2();
			    this.drawLineChart3();
				this.startAnimation();
			});
			
			// this.accinfo();
			// this.$nextTick(() => {
			// 	setTimeout(() => {
			// 	  this.startAnimation();
			// 	},200);
			// });
			
		//	this.audioTitleScroll();
			//代理标识设置
			if(this.$router.history.current.query.agent){
				localStorage.setItem('agent', this.$router.history.current.query.agent);
			}
			//APP识别
			if(this.$router.history.current.query.isapp){
				localStorage.setItem('isapp', 'true');
			}
			this.isapp = localStorage.getItem('isapp')!=null;
			
			var that = this;
			document.body.addEventListener("scroll", function() {
				if (!that.show_kefu) {
					return;
				}
				that.show_kefu = false;
			}, false);
			document.addEventListener('click', function(ev) {
				if (ev.target.className != 'kefu_img') {
					that.show_kefu = false;
				}
			}, false);
		},
		beforeDestroy() {
			clearInterval(this.intervalId); // 组件销毁前清除定时器
		},
		methods: {
			getnamestr(){
				if(this.cashes && this.cashes.length>0){
					for (let i = 0; i < this.cashes.length; i++) {
						var nameindex = Math.floor(Math.random() * this.names.length) ;
						this.notifyStr += this.names[nameindex]+" " + this.$t('e.getcommission') +":"+this.cashes[i]['money']+" " + this.$t('e.usdc') +";        ";
					}
				}
				
			},
			drawLineChart3() {
				const canvas = this.$refs.lineChart3;  // 获取 canvas 元素
				const ctx = canvas.getContext('2d');  // 获取绘图上下文
		  
				const width = canvas.width;
				const height = canvas.height;
		  
				// 清空画布
				ctx.clearRect(0, 0, width, height);
		  
				// 计算每个数据点的横坐标
				const spacing = width / (this.dataPoints3.length + 1);  // 数据点之间的间隔
		  
				// 绘制上方区域的颜色
				ctx.fillStyle = '#F1BB0E';  // 上方区域的颜色
		  
				// 绘制上方区域（折线与顶部之间的区域）
				ctx.beginPath();
				ctx.moveTo(0, 0);  // 移动到左上角
				this.dataPoints3.forEach((value, index) => {
				  const x = (index + 1) * spacing;  // 横坐标
				  const y = height - (value * height / 100);  // 纵坐标，根据最大值将数据映射到画布高度
				  ctx.lineTo(x, y);  // 绘制折线
				});
		  
				ctx.lineTo(width, 0);  // 连接到右上角
				ctx.closePath();  // 闭合路径
				ctx.fill();  // 填充上方区域
		  
				// 绘制折线图
				ctx.strokeStyle = '#F1BB0E';  // 折线的颜色（黄色）
				ctx.lineWidth = 2;  // 设置线条宽度
				ctx.beginPath();
		  
				this.dataPoints3.forEach((value, index) => {
				  const x = (index + 1) * spacing;
				  const y = height - (value * height / 100);
				  if (index === 0) {
					ctx.moveTo(x, y);  // 移动到第一个点
				  } else {
					ctx.lineTo(x, y);  // 绘制线段
				  }
				});
		  
				// 结束并绘制折线
				ctx.stroke();
			},
			drawLineChart() {
				const canvas = this.$refs.lineChart;
				const ctx = canvas.getContext('2d');

				const width = canvas.width;
				const height = canvas.height;

				// 清空画布
				ctx.clearRect(0, 0, width, height);

				// 设置折线图的颜色为 #F1BB0E（黄色）
				ctx.strokeStyle = '#F1BB0E';  // 折线颜色
				ctx.lineWidth = 2;  // 设置线条宽度
				ctx.beginPath();

				// 计算每个数据点的横坐标
				const spacing = width / (this.dataPoints.length + 1);  // 数据点之间的间隔

				// 绘制折线
				this.dataPoints.forEach((value, index) => {
					const x = (index + 1) * spacing;  // 横坐标
					const y = height - (value * height / 100);  // 反转 y 坐标，因为 canvas 的 y 轴从上往下递增

					if (index === 0) {
						ctx.moveTo(x, y);  // 移动到第一个点
					} else {
						ctx.lineTo(x, y);  // 绘制线段
					}
				});

				// 结束并绘制折线
				ctx.stroke();
			},
			drawLineChart2() {
			  const canvas = this.$refs.lineChart2;  // 获取 canvas 元素
			  const ctx = canvas.getContext('2d');  // 获取绘图上下文
		
			  const width = canvas.width;
			  const height = canvas.height;
		
			  // 清空画布
			  ctx.clearRect(0, 0, width, height);
		
			  // 设置折线图的颜色为 #F1BB0E（黄色）
			  ctx.strokeStyle = '#F1BB0E';  // 折线颜色
			  ctx.lineWidth = 2;  // 设置线条宽度
			  ctx.beginPath();
		
			  // 计算每个数据点的横坐标
			  const spacing = width / (this.dataPoints2.length + 1);  // 数据点之间的间隔
		
			  // 绘制阴影
			  ctx.fillStyle = '#F1BB0E';  // 阴影颜色（黄色）
			  ctx.beginPath();
			  this.dataPoints2.forEach((value, index) => {
				const x = (index + 1) * spacing;  // 横坐标
				const y = height - (value * height / 100);  // 纵坐标，根据最大值将数据映射到画布高度
		
				if (index === 0) {
				  ctx.moveTo(x, y);  // 移动到第一个点
				} else {
				  ctx.lineTo(x, y);  // 绘制线段
				}
			  });
		
			  // 填充折线下方的区域（阴影区域）
			  ctx.lineTo(width, height);  // 连到画布底部
			  ctx.lineTo(0, height);  // 从左边连到画布底部
			  ctx.closePath();  // 闭合路径
			  ctx.globalAlpha = 0.3;  // 设置阴影的透明度
			  ctx.fill();  // 填充阴影区域
		
			  // 重新绘制折线，确保折线在阴影之上
			  ctx.globalAlpha = 1;  // 恢复正常透明度
			  ctx.stroke();
			},
			startAnimation() {
				
			   // 每秒更新一次数据
			   this.intervalId = setInterval(() => {
			     // 模拟随机更新数据
			     this.dataPoints.shift();  // 移除第一个数据点
			     this.dataPoints.push(Math.floor(Math.random() * 100));  // 随机添加一个新的数据点
			     this.drawLineChart();  // 重新绘制图表
				 // 模拟随机更新数据
				 this.dataPoints2.shift();  // 移除第一个数据点
				 this.dataPoints2.push(Math.floor(Math.random() * 100));  // 随机添加一个新的数据点
				 this.drawLineChart2();  // 重新绘制图表
				 // 模拟随机更新数据
				 this.dataPoints3.shift();  // 移除第一个数据点
				 this.dataPoints3.push(Math.floor(Math.random() * 100));  // 随机添加一个新的数据点
				 this.drawLineChart3();  // 重新绘制图表
			   }, 3000);
			},
			upvip(it){
				this.$router.push('/invest');
				// if(this.vip){
				// 	if(this.vip.no < it.no){
				// 		Dialog.confirm({
				// 			title: this.$t('shopd.suretitle'),
				// 			confirmButtonText: this.$t('shopd.surebtn'),
				// 			cancelButtonText: this.$t('shopd.cancelbtn'),
				// 			message: this.$t('shopd.surec1')+it.price+ this.$t('shopd.surec2')+it.no+'?'
				// 		}).then(() => {
				// 		    Fetch('/user/upvip', {
				// 		      vip: it.id
				// 		    }).then((r) => {
				// 				if(r.code==1){
				// 					this.$router.push('/user');
				// 				}else{
				// 					this.$router.push('/invest');
				// 				}
								
				// 		    });
				// 		}).catch(() => {
						    
				// 		});
				// 	}
				// }else{
				// 	this.$router.push('/invest');
				// }
			},
			// accinfo() {
			// 	Fetch('/user/info').then((r) => {
			// 		this.acc = r.data;
			// 		this.vips= r.data.vips;
			// 		this.vip = r.data.vip;
			// 	});
			// },
			download(){
				let downloadurl = document.createElement('A');
				downloadurl.href = this.app.app_link;
				downloadurl.target = "blank";
				downloadurl.click();
			},
			kefu_to() {
				if (this.show_kefu) {
					var user = this.acc.user;
					var link = this.app.kefu_link + '&uid='+user.id+ '&name='+user.phone;
					// window.location.href = link;
					this.$router.push('/kefu');
				}
				this.show_kefu = !this.show_kefu;
			},
			hideDown() {
				this.show_img = false;
				this.$store.commit('setShowAdvert', false);
			},
			start() {
				Fetch('/user/info').then((r) => {
					this.user = r.data;
				});
				Fetch('/index/int').then((r) => {
					this.data = r.data;
					
					this.banner = r.data.banner;
					this.cashes = r.data.cashes;
					this.getnamestr();
					this.cashes2 = r.data.cashes2;
					this.curlist = this.cashes;
					this.articlessun = r.data.articlessun;
					var articles = r.data.articles;
				
					this.loading = true;
					if(r.data.popup.show==1){
						this.tc_content = r.data.popup.content;
						if(localStorage.getItem('tc')!=this.tc_content){
							localStorage.setItem('tc',this.tc_content);
							this.show_tc = true;
						}
					}
				});
				Fetch('/user/basicinfo').then((r) => {
					this.acc = r.data;
					this.tong = r.data.tong;
					this.vip = r.data.vip;
					this.vips = r.data.vips;
				});
				Fetch('/index/webconfig').then((r)=>{
					this.app = r.data;
					// this.notifyStr = this.app.notice;
				});
				this.islogin = localStorage.getItem('token')!=null;
				setTimeout(()=>{
					this.sync();
				},2000)
			},
			onChange(index) {
				let els = this.$refs.dian.querySelectorAll("div");
				for (let i = 0; i < els.length; i++) {
					els[i].className = "";
				}
				els[index].className = "selected";
			},
			sync() {
				Fetch("/index/sync", {}, null, false).then((r) => {
					var data = r.data;
					if(data && data.length>0){
						this.msg = data[0].content;
						this.show= true;
						setTimeout(()=>{
						  Fetch('/user/notice_view', {
						  	id: data[0].id
						  }).then(res => {
						  })
						},2000);
					}
				});
			},
			buy(item){
				this.sku = item;
				this.show_tz = true;
			},
			confirm(){
				Fetch("/index/item_apply", {
				  id: this.sku.id,
				  money:this.number
				}).then(r => {
					if (r.data && r.data>0) {
						this.$router.push("/invest/trx/"+r.data);
					} else {
						this.$router.push("/order");
					}
				}).catch(err=>{
				    this.psd_val = '';
				})
			},
		   audioTitleScroll() { 
				var audio_title = $(".wrap");
				audio_title.each(function() {
					titleScroll(this);
				});

				function titleScroll(wrap) {
					var div = wrap.getElementsByTagName('div')[0];
					var span = div.getElementsByTagName('span')[0];
					var span_w = 1000;
					if (span) {
						span_w = span.offsetWidth;
					}
					var div_w = wrap.offsetWidth;
					if (div_w > span_w || div.getElementsByTagName('span').length >= 2) {
						// console.log(777);
						return false;
					}
					// console.log(666);
					div.innerHTML += div.innerHTML;
					var timer = setInterval(goLeft, 20);
					$(wrap).hover(function() {
						clearInterval(timer);
					}, function() {
						timer = setInterval(goLeft, 20);
					});

					function goLeft() {
						if (span_w <= wrap.scrollLeft) {
							wrap.scrollLeft -= span_w;
						} else {
							wrap.scrollLeft++;
						}
					}
				}
			}
		}
	};
</script>
<style lang="less" scoped>
	/deep/ .van-cell{
		padding: 15px 26px;
	}
	.home_wrap {
		width: 100%;
		padding-bottom: 60px;
	}
	.red_top_bg{
		.language{
			position: absolute;
			top: 4px;
			left: 5px;
			height: 36px;
			img{
				height: 100%;
				border-radius: 50%;
				box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.1) 0px 2px 4px -2px;
			}
		}
		.msg{
			position: absolute;
			top: 5px;
			right: 45px;
			height: 30px;
			
			img{
				height: 100%;
			}
		}
		.service{
			position: absolute;
			top: 5px;
			right: 6px;
			height: 30px;
			img{
				height: 100%;
			}
		}
		.top_title{
			text-align: center;
			font-size: 24px;
			display: block;
			height: 44px;
			line-height: 44px;
		}
	}
	.langbar {
		position: relative;
	    margin-top: 44px;
		padding-top: 8px;
		height: 56px;
		background-color: #fff;

	}
    .search_box {
        width: 90%;
        height: 32px;
        background-color: #f6f6f6;
        border-radius: 17px;
		border: solid 1px #1989fa;
        margin: 8px auto;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        padding: 0 10px 0 14px;

        .fdj {
            width: 16px;
            height: 16px;
            background: url(../images/item/fdj.png) no-repeat center center;
            background-size: 100% 100%;
        }

        .search_inp {
            flex: 1;
            margin: 0 8px;
            font-size: 14px;
            color: #000000;
            line-height: 20px;
            height: 20px;
        }

        .clear_inp {
            width: 20px;
            height: 20px;
            background: url(../images/item/clear.png) no-repeat center center;
            background-size: 100% 100%;
        }
    }

	.swiper-container {
		width: 100%;
		height: 120px;
		background: none;
		margin-top: 5px;
		.van-swipe-item {
			overflow: hidden;
		}

		a {
			float: left;
			width: 100%;
			height: 100%;
		}

		img {
			border-radius: 6px;
			margin-left: 2%;
			height: 100%;
			width: 96%;
		}
	}
	.work_box {
		background: #FFFFFF;
		padding: 17px 8px 4px 8px;
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
		border-radius: 16px;
    	margin: 8px 8px;
		.item {
			width: 25%;
			text-align: center;
			margin-bottom: 10px;
			.item_img {
				width: 100%;
				border-radius: 5px;
				overflow: hidden;
				img {
					width: 44px;
					height: 44px;
				}
			}

			.item_title {
				width: 100%;
				line-height: 14px;
				font-size: 12px;
				color: #333333;
				text-align: center;
				transform: scale(0.85);
			}
		}
	}

	.work_box.query {
		.item {

			.item_img {
				border-radius: 5px;
				background: #f0f0f0;
			}

			.item_title {
				width: 100%;
				height: 14px;
				margin-left: 0;
				background: #f0f0f0;
			}
		}

	}
	.ads_box_1{
		border-radius: 13px;
		margin-top: 10px;
		text-align: center;
		img{
			width: 95%;
		}
	}
	.ads_box{
		// background: rgba(255, 255, 255, 1);
		width: 92%;
		border-radius: 5px;
		margin:5px auto 0 auto;
		display: flex;
		text-align: center;
		.ads_img{

		}
		img{
			width: 96%;
			border-radius: 5px;
		}
	}
	.items_1,
	.items_2,
	.items_3
	{
		margin: 10px 2% 0 2%;
		width: 96%;
		.items_tit {
      overflow: hidden;
			border-radius: 5px 5px 0 0 ;
			height: 44px;
			line-height: 44px;
			font-size: 16px;
			color: rgba(0, 0, 0, .8);
			background: #FFFFFF;
			border-bottom: 1px solid #F7F7F7;
			padding: 0 14px;
			display: flex;
			justify-content: space-between;
			.tit_tip{
				display: contents;
				font-size: 12px;
				font-weight: normal;
				color: #b2b2b2;
				margin-left: 10px;
			}
			.tit_more{
				font-size: 12px;
				font-weight: normal;
				color: #b2b2b2;

			}
		}
		.item{
			background: #FFFFFF;
		}
	}
	.items_1 {
		.item{
			padding: 5px;
			margin: 0 0 10px 0;
			div{
				margin: 20px 0;
			}
			.item_tit{
				text-align: center;
				overflow: hidden;
				p{
					text-overflow:ellipsis;
					white-space: nowrap;
					font-weight: bold;
					font-size: 16px;
				}
			}
			.item_rate{
				text-align: center;
				color: #FF0000;
				font-size: 22px;
				font-weight: bold;
			}
			.item_desc{
				p{
					width: 50%;
					text-align: center;
				}
			}
			.item_btn{
				text-align: center;

				button{
					margin: auto;
					width: 60%;
					min-width: 60px;
					background: #e7544d;
					color: #FFFFFF;
					padding: 10px 0px;
					border-radius: 10px;
				}
				.item_btn_over{
					background: #999;
				}
			}
		}
	}
	.items_2 {
		.item{
			display: flex;
			width: 100%;
			text-align: center;
			border-bottom: 1px solid #ECECEC;
			div{
				margin: 15px 0;
			}
			.item_rate{
				width: 20%;
				p{
					padding: 5px 0;
				}
				p:nth-child(1){
					font-weight: bold;
					font-size: 14px;
					color: #FF0000;

				}
				p:nth-child(2){
					color: #999;
					font-size: 12px;
				}
			}
			.item_tit{
				width: 55%;
				p{
					overflow:hidden;
					text-overflow:ellipsis;
					white-space:nowrap;
					padding: 5px 0;
				}
				p:nth-child(1){
					font-weight: bold;
				}
				p:nth-child(2){
					color: #999;
					font-size: 12px;
				}
			}
			.item_btn{
				width: 25%;
				button{
					min-width: 60px;
					margin-top: 12px;
					color: #1989fa;
					padding: 5px 5px;
					border-radius: 5px;
					border: 1px solid #1989fa;
				}
				.item_btn_over{
					color: #999;
					border: 1px solid #999;
				}
			}
		}
	}
	.items_3 {
		.item{
			margin-bottom: 10px;
			div{
				margin: 5px 0;
			}
			.item_div1{
				display: flex;
				justify-content: space-between;
				border-bottom: 1px solid #ECECEC;
				padding: 15px 10px;
				p:nth-child(1){
					// width: 70%;
					font-weight: bold;
					overflow:hidden;
					text-overflow:ellipsis;
					white-space:nowrap;

				}
				p:nth-child(2){
					color: green;
					font-size: 12px;
				}
			}
			.item_div2{
				display: flex;
				justify-content: space-between;
				text-align:center;
				font-size: 14px;
				div{
					width: 33.33%;
					p{
						padding: 5px 0;
					}
				}
				.item_rate{
					p:nth-child(1){
						font-weight: bold;
						color: red;
					}
					p:nth-child(2){
						color: green;
						font-size: 12px;
					}
				}
				.item_day{
					p:nth-child(1){
						font-weight: bold;
					}
					p:nth-child(2){
						color: green;
						font-size: 12px;
					}
				}
				.item_min{
					p:nth-child(1){
						font-weight: bold;
						color: red;
					}
					p:nth-child(2){
						color: green;
						font-size: 12px;
					}
				}
			}
			.item_div3{
				color: #999;
				padding: 5px 10px;
			}
			.item_div4{
				padding: 5px 10px;
				display: flex;
				justify-content: space-between;
				div:nth-child(1){
					width: 75%;
					margin-top: 16px;
				}
				.item_btn{
					width: 20%;
					button{
						min-width: 60px;
						color: #1989fa;
						padding: 5px 5px;
						border-radius: 5px;
						border: 1px solid #1989fa;
					}
					.item_btn_over{
						color: #999;
						border: 1px solid #999;
					}
				}
			}
		}
	}
	.popup{
		-webkit-box-flex: 1;
		-webkit-flex: 1;
		flex: 1;
		max-height: 60vh;
		padding: 0;
		overflow-y: auto;
		font-size: 14px;
		line-height: 20px;
	}

	.wrap {
		padding-top: 10px;
		overflow: hidden;
		width: 150px;
		cursor: pointer;
	}

	.scroll {
		width: 1200px;
		height: 30px;
		line-height: 30px;
		overflow: hidden;
	}
			
	.items_1 .item div.item_desc{
		color: #bec3ce;
		font-size: 12px;
		margin: 10px;
	}
	.notice-swipe {
		height: 40px;
		line-height: 40px;
	}
	.items_1 .item .item_btn button{
	    border-radius: 5px;
	}
	.main_problem{
		overflow: hidden;
		margin-bottom: 0px;
		padding: 10px;
		background-color: #FFFF;
		padding-bottom: 0px;
	}
	.alcenter {
	    align-items: center;
	}
	.flex-between {
	    display: flex;
	    justify-content: space-between!important;
	}
	.font-bold {
	    font-weight: 700;
	}
	.ft26 {
	    font-size: 13px;
	}
	.mb10 {
	    margin-bottom: 5px;
	}
	.c_2a2a2a {
	    color: #2a2a2a;
	}
	.ft20 {
	    font-size: 10px!important;
	}
	.main_problem img{
	    width: 60px;
	    height: 60px;
		display: inline-block;
		overflow: hidden;
		position: relative;
	}
	.main-content{
	    overflow: hidden;
	    width: 100%;
	    background: none;
	    padding: 10px 8px;
	    box-sizing: border-box;
	}
	.flex-between {
	    display: flex;
	    justify-content: space-between!important;
	}
	.main-content .link_box .label{
	    width: 48%;
	    height: 180px;
	    background-color: #fff;
	    border-radius: 10px;
	    box-shadow: 0 10px 20px 0 rgb(185 212 205 / 25%);
	    padding-top: 18px;
	    box-sizing: border-box;
	}
	.main-content .link_box .label>div:nth-child(1){
		display: block;
		width: 87px;
		height: 66px;
		margin: 0 auto 5px;
		overflow: hidden;
		position: relative;
		div{
			width: 100%;
			height: 100%;
		}
		img{
			display: block;
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
		}
	}
	.flex-center {
		justify-content: center;
		align-items: center;
		text-align: center;
		margin-top: 25px;
		line-height: 20px;
	}
	.font-bold {
	    font-weight: 700;
	}
	.ft36 {
	    font-size: 18px;
	}
	.c_48a093 {
	    color: #48a093;
	}
	.ml10 {
	    margin-left: 5px;
	}
	.c_2a2a2a {
	    color: #2a2a2a;
	}
	.main_join{
	    overflow: hidden;
	    width: 100%;
	    background-color: #fff;
	    padding: 22px 17px 28px;
	    text-align: center;
	    box-sizing: border-box;
		border-radius: 5px;
		.btn{
		    width: 159px;
		    height: 34px;
		    border-radius: 20px;
		    font-size: 16px;
		    font-weight: 700;
		    color: #fff;
		    background: linear-gradient(270deg,#4caa8e,#5bc878);
		    margin: 16px auto 0;
		    overflow: hidden;
		}
		.flex-center {
		    display: flex;
		    justify-content: center;
		    align-items: center;
		}
		img{
			width: 258px;
		}
		div:nth-child(3){
			height: auto;
			margin: 15px auto 0;
			img{
				width: 100%;
			}
		}
	}
	.ft40 {
	    font-size: 20px;
	}
	.text-center {
	    text-align: center;
	}
	.mb30 {
	    margin-bottom: 15px;
	}
	.main_join .des{
	    text-align: left;
	    margin: 0 auto;
	    line-height: 18px;
	}
	.ft20 {
	    font-size: 10px!important;
	}
	.c_9696a1 {
	    color: #9696a1;
	}
	.main_display{
	    margin-top: 35px;
	    overflow: hidden;
		.h3{
		    font-size: 20px;
		    font-weight: 700;
		    color:#FFFFFF;
		    text-align: center;
		    margin-bottom: 20px;
		}
		#box{
		    width: 100%;
		    margin-top: 54px;
			.item{
			    position: relative;
			    width: 48%;
			    height: 136px;
			    background-color: #fff;
			    border-radius: 10px;
			    padding-top: 59px;
			    box-shadow: 0 10px 20px 0 rgb(185 212 205 / 25%);
			    box-sizing: border-box;
				div:nth-child(1){
				    width: 75px;
				    height: 75px;
				    position: absolute;
				    left: 30%;
				    top: -33px;
					img{
						height: 100%;
					}
				}
				div:nth-child(2),div:nth-child(4){
					display: block;
					text-align: center;
					font-size: 12px;
					line-height: 1.1;
					color: #2a2a2a;
					margin-bottom: 10px;
				}
				div:nth-child(3){
					text-align: center;
					font-size: 20px;
					color: #02a393;
					line-height: 20px;
					font-weight: 600;
					margin-bottom: 10px;
				}
			}
		}
	}
	.main_about{
	    width: 100%;
	    overflow: hidden;
	    background-color: #fff;
	    border-radius: 10px;
	    margin-top: 28px;
	    padding: 21px 0 54px;
	    box-sizing: border-box;
		.about {
			.title{
			    text-align: center;
			    font-size: 20px;
			    font-weight: 700;
			    margin-bottom: 14px;
			    color: #2a2a2a;
			}
			div:nth-child(2){
				display: block;
				text-align: center;
				font-size: 16px;
				color: #2a2a2a;
				margin-bottom: 18px;
			}
			.content{
			    padding: 0 34px;
			    font-size: 10px;
			    color: #9696a1;
			    line-height: 16px;
			}
			div:nth-child(4){
				display: block;
				width: 280px;
				height: 164px;
				margin: 35px auto 0;
				img{
					height: 100%;
				}
			}
		}
	}
	.banner {
	   height: 40px;
	   display: flex;
	   width: 100%;
	   background: none;
	   background-size: 100% 100%;
	   position: relative;
	   flex-direction: column;
		
		p {
		    padding: 67px 0 0 52px;
		    font-size: 15px;
		    color: #b4ffec;
		    font-weight: 500;
		}
		>div {
		    padding: 10px 0 0 52px;
			color: #fff;
			font-size: 24px;
			font-weight: 700;
			position: relative;
			display: flex;
			z-index: 2;
			align-items: center;
			>span {
			    font-size: 16px;
			    margin-left: 5px;
			}
		}
		.notice {
			height: 40px;
			padding: 0;
			font-size: 14px;
			font-weight: 400;
			display: block;
			width: 100%;
			// background: linear-gradient(270deg, #f90, #746b0a);
			.icon {
			    width: 45px;
			    height: 45px;
			    line-height: 48px;
			    text-align: center;
			    position: absolute;
			    left: 0;
			    top: 1px;
				img {
				    width: 40px;
				    position: absolute;
				    top: 8px;
				    left: 8px;
				}
			}
			.text {
			    position: absolute;
			    left: 48px;
			    top: 1px;
			    right: 0;
			    line-height: 48px;
			}
		}
	}
	.tabs {
	    display: flex;
	    padding-top: 14px;
	    flex-direction: column;
		>ul {
		    list-style: none;
		    margin: 0;
		    padding: 0;
		    text-align: center;
			>li {
			    width: 33.33333%;
			    float: left;
			    background: none;
			    padding-bottom: 10px;
				>img {
				    width: 75%;
				    height: 75%;
				    margin: auto;
					height: 68px;
				}
				>p {
				    font-weight: 600;
				    font-size: 13px;
				    padding-top: 5px;
				    color: #fff;
				}
			}
		}
	}
	
	.game-list{
		.game-item {
		    display: flex;
		    justify-content: space-between;
		    align-items: center;
		    height: 50px;
		}
		.icon {
		    margin-right:10px;
		    width: 23px;
		    height: 23px;
		    border-radius: 100%;
		    overflow: hidden;
			img {
			    display: block;
			    width: 100%;
			    height: 100%;
			}
		}
		.title {
		    display: block;
		    font-size: 14px;
		}
		.info {
		    width: 119px;
		    line-height: 1;
		    text-align: left;
		}
		.time {
		    color: #ebedf0;
			font-size: 12px;
		}
		.price.mine-rise {
		    color: #17cdaf;
		}
		.price.mine-fall {
		    color: #f85963;
		}
		.price {
		    flex: 1;
		    font-size: 16px;
		    font-weight: 700;
		    text-align: right;
		    padding-right: 10px;
		}
		 .zd.mine-rise {
		    background: #17cdaf;
		}
		.zd {
		    display: block;
		    width: 79px;
		    height:27px;
		    background-color: #f85963;
		    border-radius: 5px;
		    line-height: 27px;
		    text-align: center;
		    font-size:14px;
		    color: #fff;
		}
	} 
	.notice_content{
		overflow: hidden;
		transition: top .5s;
		.notice_list {
			padding: 0;
		}
		.notice_item {
		    display: flex;
		    justify-content: space-between;
		    font-size: 14px;
		    height: 30px;
		    line-height: 30px;
			div{
			}
		}
		.gray {
			font-size: 12px;
			color: #ebedf0;
		}
	}
	.swiper-wrapper {
	    position: relative;
	    width: 100%;
	    height: 100%;
	    z-index: 1;
	    display: flex;
	    transition-property: transform;
	    box-sizing: content-box;
		.swiper-slide {
		    flex-shrink: 0;
		    width: 100%;
		    height: 100%;
		    position: relative;
		    transition-property: transform;
		}
		.van-swipe-item {
		    display: flex;
		}
		.item-left {
		    margin-right: 20px;
			img {
				overflow: hidden;
				width: 60px;
				height: 60px;
				border-radius: 100%;
				border: 5px solid #eee;
			}
		}
		.item-body {
		    flex: 1;
			text-align: left;
			line-height: 16px;
			color: #8a9089;
		}
		.people-content {
		    margin:5px 0 10px;
		    color: #8a9089;
		    font-size: 12px;
		}
		.people-name {
			font-size: 14px;
			color: #656b64;
			font-weight: 700;
		}
	}
	.ads_box{
		.items_tit{
			margin-bottom: 25px;
		}
	}
	
	
	.vip-item {
	    display: -webkit-box;
	    display: -webkit-flex;
	    display: -ms-flexbox;
	    display: flex;
	    -webkit-box-pack: justify;
	    -webkit-justify-content: space-between;
	    -ms-flex-pack: justify;
	    justify-content: space-between;
	    -webkit-box-align: center;
	    -webkit-align-items: center;
	    -ms-flex-align: center;
	    align-items: center;
	    padding: 2vw 3vw;
	    box-sizing: border-box;
	    border-radius: 8px;
	    background-color: #fff;
	    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1);
	    margin-bottom: 12px;
	    position: relative;
	    overflow: hidden;
	}
	.vip-item .vip-img {
	    width: 20vw;
	    height: 20vw;
	}
	.vip-item .vip-info {
	    text-align: left;
		width: 50%;
	}
	.vip-item .vip-info .vip-name {
	    font-size: 3.8vw;
	    color: #222;
		margin-bottom: 1vw;
		margin-top: 5%;
	}
	.vip-item .vip-info .vip-desc {
		font-size: 12px;
		color: #999;
		line-height: 1.5em;
	}
	.vip-item .action-box .ord{
		font-size: 2vw;
		font-weight: bold;
		line-height: 6vw;
		color: rgb(74, 193, 171);
	}
	.vip-item .action-box .i-icon {
	    padding: 2vw 3vw;
	    text-align: center;
	    background-color: #f1bb0e;
	    font-size: 14px;
	    color:#fff;
	    border-radius: 1.5em;
	    cursor: pointer;
	}
	
	.vip-item .absoulte-level {
	    position: absolute;
	    background: #f5f5f5;
	    color: #f1bb0e;
	    padding: 24px 16px 8px 16px;
	    border-radius: 50%;
	    top: -20px;
	    left: 40%;
	    font-size: 12px;
	}
	.vip-item .mask{
	    display: -webkit-box;
	    display: -webkit-flex;
	    display: -ms-flexbox;
	    display: flex;
	    -webkit-box-pack: center;
	    -webkit-justify-content: center;
	    -ms-flex-pack: center;
	    justify-content: center;
	    -webkit-box-align: center;
	    -webkit-align-items: center;
	    -ms-flex-align: center;
	    align-items: center;
	}
	.vip-item .mask {
	    position: absolute;
	    top: 0;
	    left: 0;
	    width: 100%;
	    height: 100%;
	    background: rgba(0,0,0,.4);
	    border-radius: 8px;
	    z-index: 2;
	}
	
	.vip-item .mask .lock-box,.index-wrap2 .vip-item .mask{
	    display: -webkit-box;
	    display: -webkit-flex;
	    display: -ms-flexbox;
	    display: flex;
	    -webkit-box-pack: center;
	    -webkit-justify-content: center;
	    -ms-flex-pack: center;
	    justify-content: center;
	    -webkit-box-align: center;
	    -webkit-align-items: center;
	    -ms-flex-align: center;
	    align-items: center;
	}
	
	.vip-item .mask .lock-box {
	    background: hsla(0,0%,100%,.4);
	    width: 50px;
	    height: 50px;
	    border-radius: 50%;
	}
	.vip-item .mask .lock-box, .index-wrap2 .vip-item .mask{
		display: -webkit-box;
		display: -webkit-flex;
		display: -ms-flexbox;
		display: flex;
		-webkit-box-pack: center;
		-webkit-justify-content: center;
		-ms-flex-pack: center;
		justify-content: center;
		-webkit-box-align: center;
		-webkit-align-items: center;
		-ms-flex-align: center;
		align-items: center;
	}
	 .my-swipe .van-swipe-item {
	    
	  }
	  .item_title{
	  	font-size: 1.3em;
	  	font-weight: bold;
	  	line-height: 6vw;
	  	margin-top: 2vw;
	  }
	.bannerswip{
		width: 90%;
		height: auto;
		margin: 5px auto;
		margin-left: 5%;
		border-radius: 10px;
		img{
			border-radius: 10px;
		}
	}
	.home_earnings{
	    width: 90%;
	    height: 41px;
	    margin: 3% 5%;
	    border-radius: 10px;
	    display: flex;
	    justify-content: space-between;
	    align-items: center;
	    padding: 0 10px;
	    background-color: #f1bb0e;
	    font-size: 15px;
		div{
			min-width: 40%;
			display: flex;
			justify-content: center;
			align-items: center;
		}
	}
	.notice_content{
		width: 90%;
		margin: 2% 5%;
		height: 36px;
		background-color: #f1bb0e;
		border-radius: 5px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 0 5px;
		.name{
			width: 50vw;
			display: block;
		}
		.value{
			width: 50vw;
			display: block;
		}
	}
	.home_module{
	    width: 90%;
	    margin: 0 5%;
	    color: #232f3e;
		h3{
		    height: 30px;
			display: block;
			font-size: 18px;
			margin-block-start: 1em;
			margin-block-end: 1em;
			margin-inline-start: 0px;
			margin-inline-end: 0px;
			font-weight: bold;
			margin-bottom: 0;
		}
		.module2_content{
		    width: 100%;
			padding-bottom: 100px;
		    display: flex;
		    justify-content: space-between;
		    flex-wrap: wrap;
		    align-items: center;
			img{
				height: 100%;
				border-radius: 10px;
				margin: 2% 0;
			}
			a{
				height: 68px;
				border-radius: 10px;
				margin: 2% 0;
			}
		}
		.home_nav{
		    width: 100%;
		    height: 140px;
		    display: flex;
		    justify-content: space-between;
		    align-items: center;
		    font-size: 15px;
			>div:first-child {
			    width: 48%;
			    height: 100%;
			    display: flex;
			    flex-direction: column;
			    align-items: center;
			    justify-content: space-between;
				.nav1{
				    background-color: #f4e1ff;
				}
				.nav2{
				    background-color: #ffd9e7;
				}
				.nav3{
				    background-color: #feeba9;
				}
				.nav_content{
				    width: 100%;
				    height: 30%;
				    display: flex;
				    justify-content: space-between;
				    align-items: center;
				    border-radius: 5px;
				    padding: 5px;
					>div:first-child {
					    width: 70%;
					    display: flex;
					    align-items: center;
					}
					.uniui-forward:before {
					    content: "\e660";
					}
					.uni-icons {
					    font-family: uniicons;
					    text-decoration: none;
					    text-align: center;
						img{
							height: 18px;
							width: 18px;
						}
					}
					img{
					    width: 26px;
					    height: 26px;
					}
					p{
					    margin-left: 3%;
					}
				}
			}
			>div:last-child {
				width: 48%;
				height: 100%;
				display: flex;
				border-radius: 5px;
				flex-direction: column;
				align-items: center;
				justify-content: space-between;
				background-color: #c3cdff;
				.rightAll{
				    position: relative;
				    box-sizing: border-box;
				    width: 100%;
				    height: 100%;
					.module_right{
					    width: 100%;
					    padding: 0 5px;
					    display: flex;
					    justify-content: space-between;
					    align-items: center;
					    margin: 3% 0;
					}
					img{
					    width: 100%;
					    height: 70%;
					}
				}
			}
		}
	}
	
	.vip-item {
	    display: -webkit-box;
	    display: -webkit-flex;
	    display: -ms-flexbox;
	    display: flex;
	    -webkit-box-pack: justify;
	    -webkit-justify-content: space-between;
	    -ms-flex-pack: justify;
	    justify-content: space-between;
	    -webkit-box-align: center;
	    -webkit-align-items: center;
	    -ms-flex-align: center;
	    align-items: center;
	    padding: 12px 16px;
	    box-sizing: border-box;
	    border-radius: 8px;
	    background-color: #fff;
	    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1);
	    margin-bottom: 12px;
	    position: relative;
	    overflow: hidden;
	}
	.vip-item .vip-img {
	    width: 50px;
	    height: 50px;
	}
	.vip-item .vip-info {
	    text-align: left;
		width: 45%;
		max-width: 200px;
	}
	.vip-item .vip-info .vip-name {
	    font-size: 13px;
	    color: #f1bb0e;
	    margin-bottom: 12px;
	}
	.vip-item .vip-info .vip-desc {
	    font-size: 12px;
	    color: #999;
	}
	
	.vip-item .action-box {
	    padding: 6px 16px 4px 16px;
	    text-align: center;
	    font-size: 14px;
	    border-radius: 40px;
	    cursor: pointer;
	}
	
	.vip-item .absoulte-level {
	    position: absolute;
	    background: #f5f5f5;
	    color: #f1bb0e;
	    padding: 24px 16px 8px 16px;
	    border-radius: 30%;
	    top: -20px;
	    left: 40%;
	    font-size: 12px;
	}
	.vip-item .mask{
	    display: -webkit-box;
	    display: -webkit-flex;
	    display: -ms-flexbox;
	    display: flex;
	    -webkit-box-pack: center;
	    -webkit-justify-content: center;
	    -ms-flex-pack: center;
	    justify-content: center;
	    -webkit-box-align: center;
	    -webkit-align-items: center;
	    -ms-flex-align: center;
	    align-items: center;
	}
	.vip-item .mask {
	    position: absolute;
	    top: 0;
	    left: 0;
	    width: 100%;
	    height: 100%;
	    background: rgba(0,0,0,.4);
	    border-radius: 8px;
	    z-index: 2;
	}
	
	.vip-item .mask .lock-box,.index-wrap2 .vip-item .mask{
	    display: -webkit-box;
	    display: -webkit-flex;
	    display: -ms-flexbox;
	    display: flex;
	    -webkit-box-pack: center;
	    -webkit-justify-content: center;
	    -ms-flex-pack: center;
	    justify-content: center;
	    -webkit-box-align: center;
	    -webkit-align-items: center;
	    -ms-flex-align: center;
	    align-items: center;
	}
	
	.vip-item .mask .lock-box {
	    background: hsla(0,0%,100%,.4);
	    width: 50px;
	    height: 50px;
	    border-radius: 50%;
	}
	.vip-item .mask .lock-box, .index-wrap2 .vip-item .mask{
		display: -webkit-box;
		display: -webkit-flex;
		display: -ms-flexbox;
		display: flex;
		-webkit-box-pack: center;
		-webkit-justify-content: center;
		-ms-flex-pack: center;
		justify-content: center;
		-webkit-box-align: center;
		-webkit-align-items: center;
		-ms-flex-align: center;
		align-items: center;
	}
	.grid-wrap {
	    display: flex;
		grid-template-columns: repeat(3,1fr);
		font-size: 14px;
		text-align: center;
		background: none !important;
		:nth-child(1) {
			margin: 5px;
			margin-left: 0; 
		}
		:nth-child(2) {
			margin: 5px;
			margin-right: 0;
		}
		.grid-item {
			width: 50%;
			line-height: 50px;
		    margin-bottom:5px;
			background: #FFF;
			padding: 5px;
			border-radius: 5px;
			    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1);
			.icon {
			    display: flex;
			    align-items: center;
			    justify-content: center;
			    height: 51px;
			    background: no-repeat 50% 50%/6.93333vw 6.93333vw;
			}
			img{
				vertical-align: top;
				width: 36px;
				margin: 5px;
			}
			span{
				font-size: 16px;
				color: #fa9832;
			}
		}
	}
	.banner {
	   height: 40px;
	   display: flex;
	   width: 100%;
	   background: none;
	   background-size: 100% 100%;
	   position: relative;
	   flex-direction: column;
	   background: #f1bb0e;
		p {
		    padding: 67px 0 0 52px;
		    font-size: 15px;
		    color: #b4ffec;
		    font-weight: 500;
		}
		>div {
		    padding: 10px 0 0 52px;
			font-size: 24px;
			font-weight: 700;
			position: relative;
			display: flex;
			z-index: 2;
			align-items: center;
			>span {
			    font-size: 16px;
			    margin-left: 5px;
			}
		}
		.notice {
			height: 40px;
			padding: 0;
			font-size: 14px;
			font-weight: 400;
			display: block;
			width: 100%;
			color: #000;
			// background: linear-gradient(270deg, #0c7f9e, #ffd543);
			.icon {
				width: 35px;
				height: 35px;
				line-height: 35px;
				text-align: center;
				
				border-radius: 35px;
				margin-top: 5px;
				margin-left: 2%;
				img {
				    width: 40px;
				    position: absolute;
				    top: 8px;
				    left: 8px;
				}
			}
			.text {
			   position: absolute;
			   left: 48px;
			   top: 1px;
			   right: 0;
			   line-height: 35px;
			   height: 35px;
			   border-radius: 5%;
			   padding: 0 3%;
			   margin-right:0;
			   margin-top: 5px;
			   padding-left: 0;
			}
		}
	}
	.van-col{
		text-align: left;
		
		div{
			color: #323232;
			font-size: 14px;
			line-height: 25px;
			height: 25px;
		}
		div:first-child{
			margin-top: 5px;
		}
		div:last-child{
			color: red;
		}
	}
	.van-col:first-child{
		img{
			width: 50px;
			height: 50px;
			margin:5px 15px;
		}
	}
	.inviteItem{
		padding: 0px 6px 0px 20px;
		margin-bottom: 1vh;
		display: flex;
		justify-content: space-between;
		align-items: center;
		text-align: left;
		box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1);
		.text{
		    color: #818181;
		    font-size: 15px;
			margin-top: 12px;
			text-align: left;
		}
		.value{
		    color: #ffa044;
		    font-size: 18px;
		    margin-top: 12px;
			text-align: left;
		}
		.f44 {
		    font-size: 25px;
		}
		.f20 {
		    font-size: 12px;
			margin-top: 12px;
		}
	}
	.bglight, .bglight2 {
	    background: linear-gradient(90deg,#fdebd5,#fff5ec)!important;
	}
	.index_menu ul{display: flex; flex-wrap: wrap;}
	.index_menu ul li{width: 25%; display: flex; align-items: center; flex-direction: column; margin: 1px 0 8px;}
	.index_menu ul li .img{
		background: #fff; 
		width: 60px; 
		height: 60px; 
		border-radius: 100%; 
		display: flex; 
		align-items: center; 
		justify-content: center;
		box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1) !important;
	}
	.index_menu ul li img{display: block; height: 30px; }
	.index_menu ul li p{color:#000; margin-top: 5px; text-align: center;}


	#app3 {
		width: 100%;
		height: 520px;
		overflow: hidden;
		position: relative;
		padding-left: 5%;
	  .scross {
	    position: relative;
	    top: 0;
	  }
	  
	  .list {
	    height: 92px;
	    line-height: 92px;
	    text-align: center;
	    // background-color: #f1f1f1;
	    margin-bottom: 0;
	  }
	  .list,.val{
	      display: flex;
	      align-items: center; 
	      // border-bottom: 1px solid #f5f5f5;
	      padding:0 10px;
	      width: 100%;
	  }
	  .list>.val>.lef{
	      margin-right:8px;
	      display: inline-block;
	      width: 50px;
	      height: 50px;
	      overflow: hidden;
	  }
	  .list>.val>.lef>img{
	      display: inline-block;
	      width: 50px;
	      height: 50px;
	      border-radius: 50%;
	      /*background: red;*/
	  
	  
	  }
	  .list>.val>.rig>.nav{
	     font-size: 14px;
	     font-weight: bold;
	     margin-bottom: 6px;
	  }
	  .list>.val>.rig>.navVal{
	      font-size: 12px;
	  	text-align: left;
	      margin-bottom: 6px;
	   }
	   .list .rig{
	  	 line-height: 20px;
	   }
	}
	
	.rank{
	  background: #fff;
	}
	.titList{
	    display: flex;
	    align-items: center;
	    justify-content: space-between;
	    border-bottom: 1px solid #f5f5f5;
	    box-sizing: border-box;
	}
	.titList>.name{
	    flex:1;
	    display: flex;
	    align-items: center;
	    justify-content: center;
	    height:40px;
	    background: #989898;
	    color:#fff;
	
	}
	.actives{
	    background: #c4c3c3 !important;
	}
	.titList>.name>img{
	    width:20px;
	    height:20px;
	    /*background: red;*/
	    margin-right:5px;
	}
	.tabsList {
	    margin: 15px 0px 0;
	   ul {
	       display: flex;
	       flex-wrap: wrap;
	       justify-content: space-between;
	   }
	    ul li {
		   width: 25%;
		   font-size: 14px;
		   text-align: center;
		   padding: 5px ;
	   }

	   // ul li:nth-of-type(1) img {
		  //  background: linear-gradient(rgb(255, 145, 50), rgb(253, 213, 177));
	   // }

	   // ul li:nth-of-type(2) img {
		  //  background: linear-gradient(rgb(99, 52, 254), rgb(190, 171, 253));
	   // }

	   // ul li:nth-of-type(3) img {
		  //  background: linear-gradient(rgb(255, 50, 132), rgb(252, 170, 202));
	   // }

	   // ul li:nth-of-type(4) img {
		  //  background: linear-gradient(rgb(196, 195, 195), rgb(102, 157, 255));
	   // }

	   // ul li:nth-of-type(6) img {
		  //  background: linear-gradient(rgb(102, 157, 255), rgb(102, 157, 255));
	   // }

	   ul li div {
		   color: #333;
		   font-size: 12px;
		   line-height: 20px;
	   }

	   ul li img {
		   display: inline-block;
		   width: 38px;
		   height: 38px;
		   border-radius: 8px;
		   margin-bottom: 3px;
		   // box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1);
	   }
	}
	
	.user_money{
		display: block;
		width: 94%;
		margin-left: 3%;
	    background-color: #fff;
	    border-radius: 10px;
	    padding: 15px;
	    margin-top: 10px;
	    // background: url(../images/user/smallBackground.png) no-repeat;
	    background-size: cover;
	    background-position: 50%;
		box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1);
		justify-content: space-between;
		text-align: center;
		.money_num{
		    width: auto;
		    height: 40px;
		    display: flex;
		    align-items: center;
		    justify-content: space-between;
		    font-size: 12px;
			p{
				margin: 10px 0;
			}
			div{
				width: 100%;
			}
			p:nth-child(2){
				font-size: 14px;
				color: #d3d5d6;
			}
			p:nth-child(1){
				font-size: 18px;
				font-weight: 700;
				color: #FFFFFF;
			}
			>div:first-child {
			    // display: flex;
			    align-items: center;
				img{
				    width: 20px;
				    height: 20px;
					display: inline-block;
					overflow: hidden;
					position: relative;
				}
				p{
					font-weight: bold;
					color: #000000e6;
					font-size: 17px;
					margin: 0px 5px;
				}
			}
		}
		.user_but{
		    display: flex;
		    justify-content: space-around;
		    align-items: center;
			.but_click{
			    width: 45%;
			    height: 40px;
			    border-radius: 10px;
			    display: flex;
			    align-items: center;
			    justify-content: center;
			}
		}
		.border-left-dotted {
		    border-left: 1px dashed rgba(0, 0, 0, 0.1) !important;
		}
		
		.border-top, .border-left, .border-bottom, .border-right {
			border-color: rgba(0, 0, 0, 0.1) !important;
		}
		.card-body {
		    -ms-flex: 1 1 auto;
		    flex: 1 1 auto;
		    min-height: 1px;
			padding: 15px;
			border-bottom: solid 1px;
			margin-bottom: 15px;
			padding-top: 0px;
			padding-bottom: 10px;
		}
		.row {
		    display: -ms-flexbox;
		    display: flex;
		    -ms-flex-wrap: wrap;
		    flex-wrap: wrap;
		    margin-right: -15px;
		    margin-left: -15px;
		}
		.col {
		    -ms-flex-preferred-size: 0;
		    flex-basis: 0;
		    -ms-flex-positive: 1;
		    flex-grow: 1;
		    max-width: 100%;
			text-align: left;
		}
		.font-weight-normal {
		    font-weight: 400!important;
		}
		.mb-0, .my-0 {
		    margin-bottom: 0!important;
		}
		h3 {
		    font-size: 30px;
			line-height: 36px;
		}
		.col-auto {
		    -ms-flex: 0 0 auto;
		    flex: 0 0 auto;
		    width: auto;
		    max-width: 100%;
		}
		.text-mute {
		    opacity: 0.7;
			font-size: 16px;
			line-height: 22px;
		}
	}
	/deep/ .van-cell {
		 padding: 10px 8px;
	}
	.ifm {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 20px 5% 0;
	}

	.ifm .left div:last-child {
		margin-top: 10px;
		font-size: 12px;
	}

	.ifm div span:first-child {
		font-weight: bold;
		font-size: 28px;
	}

	.ifm div span:last-child {
		font-weight: bold;
		font-size: 16px;
		color: #f1bb0e;
		margin-left: 40px;
	}

	.ifm img {
		display: flex;
		width: 40px;
		height: 40px;
		border-radius: 50%;
		box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1);
	}
	
	.con {
	    width: 100%;
	    background-color: #fff;
	    padding-bottom: 96px;
		.charts {
		    padding: 16px 16px 0;
		    box-sizing: border-box;
		}
		
		.charts .charts-left {
		    min-height: 170px;
		    display: flex;
		    flex-direction: column;
		    align-items: center;
		    justify-content: space-between;
		    box-sizing: border-box
		}
		
		.charts .charts-left .left-top,.charts .charts-left .left-bottom {
		    position: relative;
		    min-width: 135px;
		    max-width: 135px;
		    box-sizing: border-box;
		    border: 1px solid #F1BB0E;
		    border-radius: 12px;
		    padding: 9px 8px
		}
		
		.charts .charts-left .left-top .char1,.charts .charts-left .left-bottom .char1 {
		    position: absolute;
		    right: 3px;
		    bottom: 8px;
		    height: 100%
		}
		
		.charts .charts-left .left-top div:nth-child(1),.charts .charts-left .left-bottom div:nth-child(1) {
		    font-size: 12px;
			line-height: 19px;
		}
		
		.charts .charts-left .left-top div:nth-child(2),.charts .charts-left .left-bottom div:nth-child(2) {
		    margin-top: -4px;
		    font-size: 20px;
		    font-weight: 700;
			line-height: 32px;
		}
		
		.charts .charts-left .left-top div:nth-child(3),.charts .charts-left .left-bottom div:nth-child(3) {
		    margin-top: -4px;
		    font-size: 10px;
			line-height: 19px;
		}
		
		.charts .charts-left .left-bottom img {
		    position: absolute;
		    right: 0;
		    z-index: 99;
		    width: 37px;
		    height: 16px;
		    top: 50px;
		    left: 60px
		}
		
		.charts .charts-left .left-bottom div:nth-child(3) {
		    background-color: #000;
		    color: #fff;
		    padding: 0 3px;
		    width: max-content;
		    text-align: center;
		    border-radius: 4px
		}
		
		.charts .charts-right1 {
		    margin: 0 6px
		}
		
		.charts .charts-right2 div:nth-child(3) {
		    background-color: #000;
		    color: #fff;
		    padding: 0 3px;
		    width: max-content;
		    text-align: center;
		    border-radius: 4px
		}
		
		.charts .charts-right1,.charts .charts-right2 {
		    flex: 1;
		    position: relative;
		    box-sizing: border-box;
		    min-width: 96px;
		    max-width:112px;
		    min-height: 170px;
		    border: 1px solid #F1BB0E;
		    padding: 6px 6px 0;
		    border-radius: 12px;
		    overflow: hidden
		}
		
		.charts .charts-right1 div:nth-child(1),.charts .charts-right2 div:nth-child(1) {
		    font-size: 12px;
			line-height: 19px;
		}
		
		.charts .charts-right1 div:nth-child(2),.charts .charts-right2 div:nth-child(2) {
		    font-size: 20px;
		    font-weight: 700;
			line-height: 32px;
		}
		
		.charts .charts-right1 div:nth-child(3),.charts .charts-right2 div:nth-child(3) {
		    font-size: 10px;
			line-height: 19px;
			word-break: auto-phrase;
		}
		
		.charts .charts-right1 .char,.charts .charts-right2 .char {
		    position: absolute;
		    bottom: -3px;
		    left: -1px;
		    border-radius: 12px;
		    overflow: hidden
		}
		
		.charts .charts-right1 img,.charts .charts-right2 img {
		    width: 100%;
		    position: absolute;
		    left: 0;
		    bottom: 0
		}
		
		.vip-box {
		    width: 100%;
		    padding: 0 16px;
		    box-sizing: border-box
		}
		
		.vip-box .header2 {
		    padding: 12px 0;
		    width: 100%;
		}
		
		.vip-box .header2 .label {
		    width: 35%;
		    font-weight: 700;
			font-size: 15px;
		    color: #000;
		}
		
		.vip-box .header2 .more {
		    width: 65%
		}
		
		.vip-box .header2 .more .text {
		    font-weight: 700
		}
		
		.vip-box .header2 .more .img {
		    width: 14px;
		    height:14px;
		    margin-left: 3px
		}
		
		.vip-box .svip {
		    background: #F1BB0E;
		    border-radius: 4px;
		    padding: 0 8px;
		    height: 65px;
		    color: #000;
		}
		
		.vip-box .svip span,.vip-box .svip i {
		    font-weight: 700;
		    margin-left: 8px
		}
		
		.vip-box .svip img {
		    width: 36px;
		    height: 36px
		}
		
		.notice-swipe {
		    height: 28px
		}
		
		.notice-swipe .notice-swipe-item {
		    height: 28px;
		    line-height: 28px
		}
		.VipLevel {
		    width: 100%;
		    height:65px;
		    background: #F1BB0E;
		    border-radius: 8px;
		    padding: 0 10px;
		    color: #000
		}
		
		.VipLevel .left .level {
		    font-size: 16px;
		    font-weight: 700;
		    margin-left:10px
		}
		
		.VipLevel .right .clickToEnte {
		    font-size: 14px;
		    font-weight: 700
		}
		.flex-b-s {
		    display: flex;
		    justify-content: space-between;
		    align-items: flex-start;
		}
		
		.flex-b-c {
		    display: flex;
		    justify-content: space-between;
		    align-items: center
		}
	}
	
	
	.cards{
		padding: 16px;
		margin: 16px;
		border-radius: 8px;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		color: #FFF;
		line-height: 20px;
		background: linear-gradient(180deg, #000 0%, #000 100%);
		.flex-e-s {
		    display: flex;
		    justify-content: space-between;
		    align-items: flex-end;
		}
		.top {
		    margin-bottom: 8px;
		}
		
		.top div {
		    font-weight: 700;
			font-size: 15px;
			line-height: 25px;
		}
		
		.top .top-left>div:last-child {
		    word-break: break-all;
		    font-style: italic;
		    font-size:26px;
			    
		}
		.flex-b-c {
		    display: flex;
		    justify-content: space-between;
		    align-items: center;
		}
		.top .top-left>div:last-child span {
		    font-style: normal;
		    font-size: 12px;
			font-weight: 400;
		}
		
		.top .top-right {
		    text-align: center
		}
		
		.top .top-right .group {
		    background-color: var(--84e63418);
		    color: var(--78b8770c);
		    padding: 2px 5px;
		    font-size: 12px;
		    flex-shrink: 0
		}
		
		.top .top-right .group img {
		    margin-right:4px
		}
		
		.top .top-right>div:first-child {
		    margin-bottom: 8px
		}
		
		.top .top-right div {
		    background-color: #fff;
		    padding: 2px 8px;
		    color: #000;
		    border-radius: 8px
		}
		
		.middle {
		    display: flex;
		    align-items: center
		}
		
		.middle span:first-child {
		    margin-right: 10px;
		}
		
		.middle span {
		    display: inline-block;
		    font-size: 12px;
		    padding: 2px 5px;
		    text-align: center;
		    color: #FFF;
		    border: 1px solid #FFF;
		    border-radius: 4px;
			line-height: 20px;
		}
		
		.mActive {
		    background-color: #F1BB0E;
		    color: #000!important;
		    border: none!important
		}
		
		.bottom {
		    margin-top: 8px
		}
		
		.bottom .bottom-left .left-item:not(:last-child) {
		    border-right: 1px solid #F1BB0E
		}
		
		.bottom .bottom-left .left-item:last-child {
		    margin-right: 0
		}
		
		.bottom .bottom-left .left-item {
		    display: flex;
		    flex-direction: column;
		    align-items: start;
		    justify-content: center;
		    margin-right: 10px;
		    padding-right: 10px;
		    font-size: 16px
		}
		
		.bottom .bottom-left .left-item div {
		    color: var(--40ca1237)
		}
		
		.bottom .bottom-left .left-item div:first-child {
		    opacity: .8;
		    font-size: 12px
		}
		
		.bottom .bottom-left .left-item div:last-child {
		    font-weight: 600;
		    word-break: break-all
		}
	}
	#iframe {
	    width: 100%;
	    height: calc(100vh - 105px);
	    overflow-y: scroll;
	    border: none;
	}
	#iframe {
	    width: 100%;
	    // height: 100vh;
	    overflow-y: scroll;
	    border: none;
	    z-index: 2000;
	}
</style>
